export const PLAYER_ADVANCE_DUNGEON = {
  copy: 'You advance to lv. %1',
  direction: 'outbound',
};

export const PLAYER_ADVANCE_ENCOUNTER = {
  copy: 'You encounter enemy %1',
  direction: 'outbound',
};
